/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal team info for lists and cards
 * @export
 * @interface TeamBasic
 */
export interface TeamBasic {
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    clubName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    status?: TeamBasicStatus;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    awayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBasic
     */
    goalkeeperColor?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamBasic
     */
    playersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamBasic
     */
    officialsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TeamBasic
     */
    receiptUploaded?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum TeamBasicStatus {
    Registered = 'registered',
    Validated = 'validated',
    PendingPayment = 'pending_payment',
    Accepted = 'accepted',
    Rejected = 'rejected'
}


/**
 * Check if a given object implements the TeamBasic interface.
 */
export function instanceOfTeamBasic(value: object): value is TeamBasic {
    return true;
}

export function TeamBasicFromJSON(json: any): TeamBasic {
    return TeamBasicFromJSONTyped(json, false);
}

export function TeamBasicFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamBasic {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'clubName': json['club_name'] == null ? undefined : json['club_name'],
        'categoryId': json['category_id'] == null ? undefined : json['category_id'],
        'categoryName': json['category_name'] == null ? undefined : json['category_name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'email': json['email'] == null ? undefined : json['email'],
        'status': json['status'] == null ? undefined : json['status'],
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'homeColor': json['home_color'] == null ? undefined : json['home_color'],
        'awayColor': json['away_color'] == null ? undefined : json['away_color'],
        'goalkeeperColor': json['goalkeeper_color'] == null ? undefined : json['goalkeeper_color'],
        'playersCount': json['players_count'] == null ? undefined : json['players_count'],
        'officialsCount': json['officials_count'] == null ? undefined : json['officials_count'],
        'receiptUploaded': json['receipt_uploaded'] == null ? undefined : json['receipt_uploaded'],
    };
}

export function TeamBasicToJSON(json: any): TeamBasic {
    return TeamBasicToJSONTyped(json, false);
}

export function TeamBasicToJSONTyped(value?: TeamBasic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'club_name': value['clubName'],
        'category_id': value['categoryId'],
        'category_name': value['categoryName'],
        'gender': value['gender'],
        'email': value['email'],
        'status': value['status'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'home_color': value['homeColor'],
        'away_color': value['awayColor'],
        'goalkeeper_color': value['goalkeeperColor'],
        'players_count': value['playersCount'],
        'officials_count': value['officialsCount'],
        'receipt_uploaded': value['receiptUploaded'],
    };
}

